import React, { useEffect, useState } from "react";
import { Button, Card, Col, Nav, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";
import MyAppointmentTable from "../components/tables/MyAppointmentsTable";
import AppointmentSidebar from "../components/common/appointmentSidebar";
import AppointmentHistoryTab from "../components/tabs/AppointmentHistoryTab";
import { useDashboard } from "../context/dashboardContext";
import useManageVisits from "../hooks/patientDashboard/useManageVisits";
import VisitSummaryTable from "../components/tabs/VisitSummaryTable";

export default function MyAppointments() {
  const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
  const [skin, setSkin] = useState(currentSkin);
  const [tabs, setTabs] = useState("upcoming");
  const location = useLocation();
  const navigate = useNavigate();

  const { handleFetchVisitsSummary, Visits, loading: isLoadingVisits } = useManageVisits();
  const {
    appointments,
    upcommingAppointments,
    loading,
    handleFetAppointments,
    handleFetchUpcommingAppointments,
  } = useDashboard();

  useEffect(() => {
    handleFetchVisitsSummary();
    handleFetAppointments();
    handleFetchUpcommingAppointments();
  }, []);

  useEffect(() => {
    if (location.hash) {
      setTabs(location.hash.replace("#", ""));
      return;
    }

    setTabs("upcoming");
  }, [location]);

  const handleTabChange = (tab) => {
    setTabs(tab);
    navigate(`#${tab}`);
  };

  const activeCount = Array.isArray(upcommingAppointments) ? upcommingAppointments.length : 0;
  const historyCount = Array.isArray(appointments) ? appointments.length : 0;
  const summaryCount = Array.isArray(Visits?.summary) ? Visits.summary.length : 0;

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className={`main main-app p-3 p-lg-4 ${skin}`}>
        <div className="data-page-hero">
          <div className="data-page-copy">
            <span className="data-page-kicker">Appointments</span>
            <h2>Manage your visits with less friction</h2>
            <p>
              See what is coming up, review past appointments, and browse visit summaries
              from one cleaner workspace.
            </p>
          </div>

          <div className="data-page-stats">
            <div className="data-page-stat">
              <small>Upcoming</small>
              <strong>{activeCount}</strong>
            </div>
            <div className="data-page-stat">
              <small>History</small>
              <strong>{historyCount}</strong>
            </div>
            <div className="data-page-stat">
              <small>Summaries</small>
              <strong>{summaryCount}</strong>
            </div>
          </div>
        </div>

        <Row className="gx-4">
          <Col xl="9">
            <Nav className="nav-line mb-4">
              <Button onClick={() => navigate("/appointment/schedule")} variant="link">
                Book Appointment
              </Button>
              <Button
                onClick={() => handleTabChange("upcoming")}
                variant="link"
                className={tabs === "upcoming" ? "active" : ""}
              >
                Upcoming Appointments
              </Button>
              <Button
                onClick={() => handleTabChange("history")}
                variant="link"
                className={tabs === "history" ? "active" : ""}
              >
                Appointment History
              </Button>
              <Button
                onClick={() => handleTabChange("summary")}
                variant="link"
                className={tabs === "summary" ? "active" : ""}
              >
                Visit Summary
              </Button>
            </Nav>

            <Card className="data-panel">
              {tabs === "upcoming" && <MyAppointmentTable data={upcommingAppointments} />}
              {tabs === "history" && <AppointmentHistoryTab data={appointments} loading={loading} />}
              {tabs === "summary" && (
                <div className="data-table-shell">
                  <VisitSummaryTable data={Visits?.summary} loading={isLoadingVisits} />
                </div>
              )}
            </Card>

            <Footer />
          </Col>

          <AppointmentSidebar />
        </Row>
      </div>
    </React.Fragment>
  );
}
